module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e7b81f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/Clients.vue
// module id = 202
// module chunks = 1